<script setup lang="ts">
const handleBookDemo = () => {
  // Handle demo booking
  console.log('Book demo clicked')
}

const handleTalkToSales = () => {
  // Handle sales contact
  console.log('Talk to sales clicked')
}
</script>

<template>
  <section class="py-16 bg-gray-50 dark:bg-gray-800/50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Get in Touch
        </h2>
        <p class="text-lg text-gray-600 dark:text-gray-400">
          Let us help you transform your business
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Book a Demo -->
        <div class="bg-white dark:bg-gray-800 rounded-xl p-8 text-center">
          <div class="mb-6 relative">
            <div class="w-24 h-24 mx-auto bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
              <span class="text-4xl">📅</span>
            </div>
            <!-- Decorative elements -->
            <div class="absolute top-0 right-1/4 w-8 h-8 bg-yellow-100 dark:bg-yellow-900/50 rounded-full flex items-center justify-center">
              <span class="text-xl">💡</span>
            </div>
            <div class="absolute bottom-0 left-1/4 w-10 h-10 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center">
              <span class="text-2xl">✨</span>
            </div>
          </div>
          
          <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Book a Demo
          </h3>
          <p class="text-gray-600 dark:text-gray-400 mb-6">
            See our solution in action with a personalized demo tailored to your business needs
          </p>
          <button
            @click="handleBookDemo"
            class="w-full px-6 py-3 text-base font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
          >
            Schedule Demo
          </button>
        </div>

        <!-- Talk to Sales -->
        <div class="bg-white dark:bg-gray-800 rounded-xl p-8 text-center">
          <div class="mb-6 relative">
            <div class="w-24 h-24 mx-auto bg-purple-100 dark:bg-purple-900/50 rounded-full flex items-center justify-center">
              <span class="text-4xl">💬</span>
            </div>
            <!-- Decorative elements -->
            <div class="absolute top-0 left-1/4 w-8 h-8 bg-pink-100 dark:bg-pink-900/50 rounded-full flex items-center justify-center">
              <span class="text-xl">🎯</span>
            </div>
            <div class="absolute bottom-0 right-1/4 w-10 h-10 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
              <span class="text-2xl">🤝</span>
            </div>
          </div>
          
          <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Talk to Sales
          </h3>
          <p class="text-gray-600 dark:text-gray-400 mb-6">
            Connect with our sales team to find the perfect solution for your business
          </p>
          <button
            @click="handleTalkToSales"
            class="w-full px-6 py-3 text-base font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 transition-colors"
          >
            Contact Sales
          </button>
        </div>
      </div>
    </div>
  </section>
</template>